//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data(){
        return{
            // 用户基本信息
            user:{
                id:'',
                name:'',
                head_photo:'',
                card_no:'',
                card_balance:0,
                integral:0,
                member_auth1:'',
                member_auth2:'',
            },
        }
    },
    mounted(){
        // 获取基本信息
        const card =  sessionStorage.getItem("cardInfo")
        let cardInfo = JSON.parse(card)
        // console.log(cardInfo);
        this.user.id = cardInfo.id
        this.user.name = cardInfo.name
        this.user.head_photo = cardInfo.head_portrait
        this.user.card_name = cardInfo.card_name
        this.user.card_no = cardInfo.card_no
        this.user.card_balance = cardInfo.card_balance
        this.user.integral = cardInfo.integral
        this.user.use_credit = cardInfo.use_credit
        this.user.member_auth1 = [...cardInfo.member_auth1]
        this.user.member_auth2 = [...cardInfo.member_auth2]
        console.log(this.user);
    },
    methods:{
        goPath(path) {
        const query = {};
        switch (path) {
            case "xiaofeijilu":
                if (this.card_id === "") {
                    return;
                }
                query.id = this.user.id;
            break;
            case "shangcheng":
                location.href =
                "https://mall.hfbsoftware.com/#/home?token=" +
                sessionStorage.getItem("token");
            break;
        }
        console.log(path);
        if (path != "shangcheng")
            this.$router.push({
                path: `/${path}`,
                query,
            });
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/home/three.vue